import { GlobalStyles } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export default function SynopGlobalStyles() {
  const theme = useTheme()

  return (
    <GlobalStyles
      styles={() => ({
        // The global density knob: theme spacing, input chrome, and icon
        // sizes are all rem-based, so a 14px root tightens the whole UI
        // proportionally (fonts are px-sized in src/theme/typography.ts and
        // scale there). 87.5% = 14px at default browser settings.
        html: {
          fontSize: '87.5%'
        },
        body: {
          backgroundColor: theme.palette.background.layout
        },
        'a:focus-visible, button:focus-visible, [tabindex]:not([tabindex="-1"]):focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2
        },
        '.MuiGrid-container.match-height .MuiCard-root': {
          height: '100%'
        }
      })}
    />
  )
}
